/* eslint-disable no-undef */
import $ from 'jquery';

const custom_reorder = () => {
    const init = () => {
        reorder_btn();
    }

    const reorder_btn = () => {
        $(document).on('click', '.js-btn-custom-reorder', function () {
            const data = {
                'nonce'    : parameters.mi_add_to_cart.nonce_reorder,
                'action'   : parameters.mi_add_to_cart.action_reorder,
                'order_id' : $(this).data('id')
            }

            $.ajax({
                type: "POST",
                url: parameters.url_admin_ajax,
                data: data,
                success: function (response) {
                    window.location.href = response.data;
                }
            });
        });
    }

    init();
}

try {
    $(function () {
        custom_reorder();
    });
} catch (error) {
    console.error('Custom Reorder', error);
}